import { render, staticRenderFns } from "./EyeClose.vue?vue&type=template&id=069a4a7d&"
import script from "./EyeClose.vue?vue&type=script&lang=ts&"
export * from "./EyeClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports